import { Model } from "./types";
import { models as babylonModels } from './BabylonChatAvatar/constants'
import { models as lottieModels } from './LottieChatAvatar/constants'
import { models as pixiModels } from './PixiChatAvatar/constants'
import forEach from 'lodash/forEach'
import entries from 'lodash/entries'

export const DEFAULT_MODEL: Model = {
    id: 'default_model',
    name: 'teacher_hoa',
    type: '2D',
    module: 'lottie',
    settings: lottieModels['teacher_hoa'],
    voice: 'coral'
};

export class AvatarModel {
    static models: Model[] = this.initModels();

    constructor() { }

    static getModelSettingsById(id: string) {
        return AvatarModel.models.find((model) => model.id === id)
    }

    static initModels() {
        AvatarModel.models = []

        AvatarModel.processBabylonModels()
        AvatarModel.processLottieModels()
        AvatarModel.processPixiModels()

        if (AvatarModel.models.length === 0) {
            AvatarModel.models = [DEFAULT_MODEL]
        }

        return AvatarModel.models
    }

    private static processBabylonModels() {
        forEach(entries(babylonModels), ([key, value]) => {
            AvatarModel.models.push({
                id: `babylon_${key}`,
                name: value.name,
                type: '3D',
                module: 'babylon',
                settings: {
                    key,
                    ...value
                }
            })
        })
    }

    private static processLottieModels() {
        forEach(entries(lottieModels), ([key, value]) => {
            AvatarModel.models.push({
                id: `lottie_${key}`,
                name: value.name,
                type: '2D',
                module: 'lottie',
                settings: value
            })
        })
    }

    private static processPixiModels() {
        forEach(entries(pixiModels), ([key, value]) => {
            AvatarModel.models.push({
                id: `pixi_${key}`,
                name: value.name,
                type: '2D',
                module: 'pixi',
                settings: value
            })
        })
    }
}
